<template>
    <div class="beneficios">
        <div class="conteudo">
            <div class="part1">
              <label data-aos="fade-up" data-aos-duration="1000" class="titulo-geral">Nossos Benefícios</label>
              <div data-aos="fade-up" data-aos-duration="800" class="linha"></div>
              <label data-aos="fade-up" data-aos-duration="800" class="subtitulo">Nos esforçamos para entregar um aplicativo com um ambiente seguro e prático</label>
            </div>
            <div class="part2">
              <label data-aos="fade-left" data-aos-duration="1000" class="titulo1">100% Gratuito</label>
              <img data-aos="fade-left" data-aos-duration="1000" class="img-t11" src="../../assets/images/basic.svg" alt="">
              <label data-aos="fade-left" data-aos-duration="1000" class="descricao1">Anuncie suas plantas para vender ou trocar sem gastar nada por isso.</label>
            </div>
            <div class="part3">
              <label data-aos="fade-left" data-aos-duration="1000" class="titulo2">Seguro e prático</label>
              <img data-aos="fade-left" data-aos-duration="1000" class="img-t12" src="../../assets/images/basic.svg" alt="">
              <label data-aos="fade-left" data-aos-duration="1000" class="descricao2">Você mesmo negocia no próprio aplicativo a melhor forma de comprar, vender ou trocar.</label>
            </div>
            <div class="part4">
              <label data-aos="fade-left" data-aos-duration="1000" class="titulo3">Feed em tempo real</label>
              <img data-aos="fade-left" data-aos-duration="1000" class="img-t13" src="../../assets/images/basic.svg" alt="">
              <label data-aos="fade-left" data-aos-duration="1000" class="descricao3">Tenha acesso rápido às novidades de quem vende, ou de trocas de seu interesse assim que entrarem anúncios novos.</label>
            </div>
            <div class="centro">
              <img data-aos="fade-right" data-aos-duration="1000" class="celular" src="../../assets/images/celular4.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Beneficios',
}
</script>

<style scoped lang="scss">
.beneficios{
    position: relative;
}
.conteudo{
  position: relative;
  margin: 0 auto;
  display: flex;
  max-width: 1350px;
  height: 1040px;
}
.titulo-geral{
    position: absolute;
    width: 425px;
    left: 488px;
    top: 93px;
    font-style: normal;
    font-weight: normal;
    font-size: 45px;
    line-height: 50px;
    letter-spacing: 1.2px;
    color: #4F4F4F;
}
.linha{
    position: absolute;
    width: 195px;
    left: 585px;
    top: 163px;
    border: 1px solid #1D976C;
}
.subtitulo{
    position: absolute;
    width: 640px;
    height: 68px;
    left: 363px;
    top: 178px;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 32px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.75px;
    color: #333333;
}
.celular{
    position: absolute;
    width: 320px;
    left: 236px;
    top: 310px;
}

//parte 1
.titulo1{
    position: absolute;
    width: 336px;
    left: 745px;
    top: 405px;
    font-style: normal;
    font-weight: bold;
    font-size: 31px;
    line-height: 30px;
    text-align: right;
    letter-spacing: 1px;
    color: #4F4F4F;
}
.img-t11{
    position: absolute;
    width: 32px;
    left: 1093px;
    top: 405px;
}
.descricao1{
    position: absolute;
    width: 443px;
    height: 68px;
    left: 680px;
    top: 452px;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 32px;
    text-align: right;
    letter-spacing: 0.75px;
    color: #000000;
}

//parte 2
.titulo2{
    position: absolute;
    width: 336px;
    left: 745px;
    top: 555px;
    font-style: normal;
    font-weight: bold;
    font-size: 31px;
    line-height: 30px;
    text-align: right;
    letter-spacing: 1px;
    color: #4F4F4F;
}
.img-t12{
    position: absolute;
    width: 32px;
    left: 1093px;
    top: 555px;
}
.descricao2{
    position: absolute;
    width: 443px;
    height: 68px;
    left: 680px;
    top: 602px;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 32px;
    text-align: right;
    letter-spacing: 0.75px;
    color: #000000;
}

//parte 3
.titulo3{
    position: absolute;
    width: 336px;
    left: 745px;
    top: 740px;
    font-style: normal;
    font-weight: bold;
    font-size: 31px;
    line-height: 30px;
    text-align: right;
    letter-spacing: 1px;
    color: #4F4F4F;
}
.img-t13{
    position: absolute;
    width: 32px;
    left: 1093px;
    top: 740px;
}
.descricao3{
    position: absolute;
    width: 443px;
    height: 68px;
    left: 680px;
    top: 785px;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 32px;
    text-align: right;
    letter-spacing: 0.75px;
    color: #000000;
}

@media screen and (max-width: 1365px) {
    .conteudo{
        height: 76.15vw;
    }
    .titulo-geral{
        left: 35.8vw;
        top: 6.8vw;
        font-size: 3.299vw;
    }

    .linha{
        width: 195px;
        left: 42.859vw;
        top: 11.9vw;
    }

    .subtitulo{
        width: 46.9vw;
        left: 26.61vw;
        top: 13vw;
        font-size: 1.245vw;
        line-height: 2.4vw;
    }

    .celular{
        width: 23.45vw;
        left: 17.3vw;
        top: 22.69vw
    }

    .titulo1, .titulo2, .titulo3{
        width: 24.588vw;
        left: 54.59vw;
        font-size: 2.27vw;
    }

    .titulo1{
        top: 29.65vw;
    }
    .titulo2{
        top: 40.65vw;
    }
    .titulo3{
        top: 54.2vw;
    }

    .img-t11, .img-t12, .img-t13 {
        width: 32px;
        left: 80.1vw;
    }
    .img-t11{
        top: 29.65vw;
    }

    .img-t12{
        top: 40.65vw;
    }

    .img-t13{
        top: 54.2vw;
    }

    .descricao1, .descricao2, .descricao3{
        width: 32.5vw;
        left: 49.89vw;
        font-size: 1.245vw;
        line-height: 2.4vw;
    }

    .descricao1{
        top: 33.1vw;
    }
    .descricao2{
        top: 44.1vw;
    }
    .descricao3{
        top: 57.48vw;
    }

}

@media screen and (max-width: 1116px) {
    .conteudo{
        max-width: 686px;
        height: 849.828px;
        //background-color: #697aa4;
    }
    .titulo-geral{
        left: 202.608px;
        top: 75.888px;
        font-size: 36.8168px;
    }

    .linha{
        width: 195px;
        left: 281.386px;
        top: 132.804px;
    }

    .subtitulo{
        width: 523.391px;
        left: 108.208px;
        top: 145.08px;
        font-size: 13.8942px;
        line-height: 26.784px;
    }

    .celular{
        width: 261.688px;
        left: -0.212px;
        top: 253.22px;
    }

    .titulo1, .titulo2, .titulo3{
        width: 274.391px;
        left: 366.144px;
        font-size: 25.3332px;
    }

    .titulo1{
        top: 330.894px;
    }
    .titulo2{
        top: 453.654px;
    }
    .titulo3{
        top: 604.872px;
    }

    .img-t11, .img-t12, .img-t13 {
        width: 32px;
        left: 650.836px;
    }
    .img-t11{
        top: 330.894px;
    }

    .img-t12{
        top: 453.654px;
    }

    .img-t13{
        top: 604.872px;
    }

    .descricao1, .descricao2, .descricao3{
        width: 362.688px;
        left: 316.692px;
        font-size: 13.8942px;
        line-height: 26.784px;
    }

    .descricao1{
        top: 369.396px;
    }
    .descricao2{
        top: 492.156px;
    }
    .descricao3{
        top: 641.477px;
    }
}

@media screen and (max-width: 767px) {
    .celular{
        display: none;
    }
    .conteudo{
        max-width: 399px;
        height: 605px;
        overflow: hidden;
    }
    .titulo-geral{
        width: 232px;
        left: 92px;
        top: 0px;
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 32px;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 1px;
    }

    .linha{
        width: 160px;
        left: 124px;
        top: 40px;
    }

    .subtitulo{
        font-size: 20px;
        line-height: 32px;
        width: 382px;
        height: 96px;
        top: 60px;
        left: 10px;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 0.75px;
    }

    .titulo1, .titulo2, .titulo3{
        width: 342px;
        height: 32px;
        left: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 32px;
        text-align: right;
        letter-spacing: 0.75px;
    }

    .titulo1{
        top: 182px;
    }
    .titulo2{
        top: 287px;
    }
    .titulo3{
        top: 415px;
    }

    .img-t11, .img-t12, .img-t13 {
        width: 24px;
        height: 24px;
        left: 364px;
    }
    .img-t11{
        top: 187px;
    }

    .img-t12{
        top: 293px;
    }

    .img-t13{
        top: 419px;
    }

    .descricao1, .descricao2, .descricao3{
        width: 382px;
        height: 56px;
        left: 2px;
        top: 2102px;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 28px;
        display: flex;
        align-items: center;
        text-align: right;
        letter-spacing: 0.75px;
    }

    .descricao1{
        top: 217px;
    }
    .descricao2{
        top: 336px;
    }
    .descricao3{
        top: 463px;
    }
}


@media screen and (max-width: 398px) {
    .celular{
        display: none;
    }
    .conteudo{
        max-width: 360px;
        overflow: hidden;
        height: 530px;
    }
    .titulo-geral{
        width: 232px;
        left: 76px;
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 32px;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 1px;
    }

    .linha{
        width: 160px;
        left: 108px;
    }

    .subtitulo{
        font-size: 16px;
        line-height: 32px;
        width: 313px;
        height: 96px;
        left: 25px;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 0.75px;
    }

    .titulo1, .titulo2, .titulo3{
        width: 238px;
        height: 32px;
        left: 65px;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 32px;
        text-align: right;
        letter-spacing: 0.75px;
    }

    .img-t11, .img-t12, .img-t13 {
        width: 24px;
        height: 24px;
        left: 313px;
    }

    .descricao1, .descricao2, .descricao3{
        width: 322px;
        left: 17px;
        top: 2102px;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 22px;
        display: flex;
        align-items: center;
        text-align: right;
        letter-spacing: 0.75px;
    }
    .titulo1{
        top: 182px;
    }
    .titulo2{
        top: 272px;
    }
    .titulo3{
        top: 384px;
    }

    .img-t11{
        top: 187px;
    }

    .img-t12{
        top: 277px;
    }

    .img-t13{
        top: 388px;
    }

    .descricao1{
        top: 208px;
    }
    .descricao2{
        top: 312px;
    }
    .descricao3{
        top: 422px;
    }
}
</style>
